import {
  Action,
  ActionType,
  BodyTemperatureFileResponse,
} from "models/bodyTemperature/file";
import createReducer from "../../createReducer";

export interface BodyTemperatureFileReducerType {
  loading: boolean;
  error?: string;
  bodyTemperatureFileResponse?: BodyTemperatureFileResponse;
}

const defaultState: BodyTemperatureFileReducerType = {
  loading: false,
  error: undefined,
  bodyTemperatureFileResponse: undefined,
};

export const getBodyTemperatureFileDataReducer =
  createReducer<BodyTemperatureFileReducerType>(defaultState, {
    [ActionType.BODY_TEMPERATURE_FILE_DATA](
      state: BodyTemperatureFileReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.BODY_TEMPERATURE_FILE_DATA_ERROR](
      state: BodyTemperatureFileReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.BODY_TEMPERATURE_FILE_DATA_SUCCESS](
      state: BodyTemperatureFileReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        bodyTemperatureFileResponse: action.payload,
      };
    },

    [ActionType.BODY_TEMPERATURE_FILE_DATA_RESET](
      state: BodyTemperatureFileReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        bodyTemperatureFileResponse: undefined,
      };
    },
  });
